import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { compose, path, nthArg } from 'ramda'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useEffect } from 'react'
import {
  selectAccessLevelsStatus,
  selectAccessLevels,
  fetchAccessLevels,
  selectAccessLevelLinkedServiceById,
  fetchAccessLevelLinkedServices,
  selectSelectedLinkedService,
  errorMessageChanged,
} from '../admin.slice'

export default ({ isSaving }: { isSaving: (bool: boolean) => void }) => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let accessLevelsStatus = useAppSelector(selectAccessLevelsStatus)
  let accessLevels = useAppSelector(selectAccessLevels)
  let accessLevelLinkedService = useAppSelector(
    selectAccessLevelLinkedServiceById(selectedLinkedService),
  )

  useEffect(() => {
    if (accessLevelsStatus === 'uninitialized') {
      dispatch(fetchAccessLevels())
    }
  }, [accessLevelsStatus])

  let onAccessLevelChanged = (accessLevel: string) => {
    isSaving(true)
    if (accessLevel === 'None') {
      axios
        .delete(
          `/api/v2/admin/access-level/linked-service?linkedServiceID=${selectedLinkedService}`,
        )
        .then(() => {
          dispatch(fetchAccessLevelLinkedServices())
          isSaving(false)
        })
        .catch((err) => {
          dispatch(errorMessageChanged(err?.response?.data))
          isSaving(false)
        })
    } else if (accessLevel && !accessLevelLinkedService) {
      axios
        .post('/api/v2/admin/access-level/linked-service', {
          accessLevelID: accessLevel,
          linkedServiceID: selectedLinkedService,
        })
        .then(() => {
          dispatch(fetchAccessLevelLinkedServices())
          isSaving(false)
        })
        .catch((err) => {
          dispatch(errorMessageChanged(err?.response?.data))
          isSaving(false)
        })
    } else if (accessLevel && accessLevelLinkedService) {
      axios
        .put('/api/v2/admin/access-level/linked-service', {
          accessLevelID: accessLevel,
          linkedServiceID: selectedLinkedService,
        })
        .then(() => {
          dispatch(fetchAccessLevelLinkedServices())
          isSaving(false)
        })
        .catch((err) => {
          dispatch(errorMessageChanged(err?.response?.data))
          isSaving(false)
        })
    }
  }

  return (
    <FormControl variant="outlined" className="w-full">
      <InputLabel>Access Level</InputLabel>
      <Select
        fullWidth
        label="Access Level"
        value={
          accessLevels.find((x) => x.id === accessLevelLinkedService?.id)?.id ??
          'None'
        }
        onChange={compose(
          onAccessLevelChanged,
          path(['target', 'value']) as any,
          nthArg(0),
        )}
        sx={{ backgroundColor: 'background.paper' }}
      >
        {[
          <MenuItem key="None" value="None">
            None
          </MenuItem>,
          ...accessLevels.map((al) => (
            <MenuItem key={al.id} value={al.id}>
              {al.name}
            </MenuItem>
          )),
        ]}
      </Select>
    </FormControl>
  )
}
